// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.7.12_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.7.12_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.color-display {
  display: inline-flex;
  align-items: center;
  font-family: monospace;
  height: 100%;
  line-height: 18px;
  text-transform: lowercase;
}
.color-display .preview {
  display: inline-block;
  width: 16px;
  height: 16px;
  border-radius: 3px;
  vertical-align: middle;
  border: 1px solid rgba(128, 128, 128, 0.5);
}
.color-display .text {
  margin-left: 8px;
}
.color-editor .nkl-select {
  width: 100%;
}
.color-editor .color-option-container {
  display: flex;
  align-items: center;
  height: 30px;
}
.color-editor .color-option-container .tint-shade-container {
  display: none;
}
.nkl-select-item-option-content .color-option-container {
  display: flex;
  align-items: center;
  height: 30px;
}
.nkl-select-item-option-content .tint-shade-container {
  display: flex;
  align-items: center;
  height: 30px;
  margin-left: auto;
}
.nkl-select-item-option-content .tint-shade-container .nkl-radio-button-wrapper {
  border: 0 !important;
  border-radius: 0 !important;
  padding: 0;
  height: 30px;
  width: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
}
.nkl-select-item-option-content .tint-shade-container .nkl-radio-button-wrapper:hover {
  background-color: #0000001a;
}
.nkl-select-item-option-content .tint-shade-container .nkl-radio-button-wrapper > span {
  display: flex;
  align-items: center;
  justify-content: center;
}
.nkl-select-item-option-content .tint-shade-container .nkl-radio-button-wrapper:not(:first-child)::before {
  background-color: transparent;
}
.branding-color-palette {
  margin-bottom: -12px;
}
.branding-color-palette .color-list {
  list-style: none;
  padding: 4px 0 0 0;
  display: flex;
  flex-wrap: wrap;
}
.branding-color-palette .color-list li {
  position: relative;
  margin-right: 12px;
  margin-bottom: 12px;
}
.branding-color-palette .color-list .color-display {
  display: flex;
  flex-direction: column;
}
.branding-color-palette .color-list .color-display .preview {
  width: 48px;
  height: 48px;
  border-radius: 8px;
}
.branding-color-palette .color-list .color-display .text {
  margin-top: 8px;
  margin-left: 0;
  font-size: 12px;
  opacity: 0.6;
}
.branding-color-palette .color-list .delete {
  position: absolute;
  top: -4px;
  right: -4px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: black;
  color: white;
  width: 18px;
  border-radius: 50%;
  font-size: 10px;
}
.branding-color-palette .color-list .add {
  width: 48px;
  height: 48px;
  border-radius: 8px;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}
.branding-color-palette .nkl-form-vertical label {
  display: flex;
  width: 100%;
}
.branding-color-palette .nkl-form-vertical label .fallback-tag-container {
  margin-left: auto;
}
.branding-color-palette .nkl-form-vertical label .fallback-tag {
  margin: 0;
}
.branding-color-palette.compact .color-list .color-display .preview {
  width: 24px;
  height: 24px;
  border-radius: 4px;
}
.branding-color-palette.compact .color-list .color-display .text {
  display: none;
}
.branding-color-palette.compact .color-list li {
  margin-right: 6px;
  margin-bottom: 6px;
}
.branding-color-palette.compact .color-list .delete {
  top: -2px;
  right: -2px;
  height: 13px;
  width: 13px;
  font-size: 7px;
}
.branding-color-palette.compact .color-list .add {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  font-size: 12px;
}
.branding-color-picker-input {
  display: flex;
  padding: 8px 0;
}
.branding-color-picker-input .color-display {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  margin-left: 12px;
}
.branding-color-picker-input .color-display .preview {
  background-color: rgba(0, 0, 0, 0);
  width: 100%;
  height: 100%;
  border-radius: 6px;
  border-color: #d9d9d9;
}
.element-property-item > .nkl-form-item-label > label {
  display: flex;
  width: 100%;
}
.nkl-form-vertical.branding-element label {
  display: flex;
  width: 100%;
}
.nkl-form-vertical.branding-element label .fallback-tag-container {
  margin-left: auto;
}
.nkl-form-vertical.branding-element label .fallback-tag {
  margin: 0;
}
.preview-container {
  background: #0000001a;
  display: flex;
  align-items: center;
  justify-items: center;
  height: 100%;
  padding: 24px;
  margin: 0 0 0 48px;
  border-radius: 4px;
}
.branding-hierarchy-menu-container {
  display: flex;
  flex-direction: column;
  width: 480px;
  max-height: 480px;
  background: white;
  padding: 16px 16px 0 16px;
  box-shadow: 0px 0px 16px 0px #00000033;
  overflow-x: hidden;
  overflow-y: auto;
}
.branding-hierarchy-menu-container .nkl-menu {
  margin: 16px -16px 0 -16px;
}
.branding-preview-element-host {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.size-editor {
  display: inline-flex;
  align-items: center;
  width: 100%;
}
.size-editor input {
  width: 251.8px !important;
}
.branding-theme-menu-container {
  display: flex;
  flex-direction: column;
  width: 480px;
  max-height: 480px;
  background: white;
  padding: 0 16px 0 16px;
  box-shadow: 0px 0px 16px 0px #00000033;
  overflow-x: hidden;
  overflow-y: auto;
}
.branding-theme-menu-container .nkl-menu {
  margin: 0 -16px 0 -16px;
}
.url-editor .image-container {
  position: relative;
  display: inline-block;
}
.url-editor .image-container img {
  border: 1px solid rgba(128, 128, 128, 0.5);
  max-width: 100%;
  max-height: 256px;
}
.url-editor .image-dimensions {
  display: block;
  text-align: center;
  font-size: 12px;
  opacity: 0.6;
  margin: 8px;
}
.url-editor .image-filename {
  display: block;
  text-align: center;
  font-size: 12px;
  opacity: 0.6;
  margin: -4px 8px 8px 8px;
}
.url-editor .delete {
  position: absolute;
  top: -4px;
  right: -4px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: black;
  color: white;
  width: 18px;
  border-radius: 50%;
  font-size: 10px;
}
.url-editor .edit {
  position: absolute;
  bottom: 48px;
  right: -8px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #1890ff;
  color: white;
  width: 36px;
  border-radius: 50%;
  font-size: 18px;
}
.nkl-image-preview-operations {
  background: rgba(0, 0, 0, 0.8);
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
